<template>
    <v-container
            id="store"
            fluid
            tag="section"
    >

        <v-breadcrumbs :items="breadcrumb">
            <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                        :to="item.href"
                        :disabled="item.disabled"
                >
                    {{ item.text.toUpperCase() }}
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>

        <v-card :loading="loading">

            <v-form
                    ref="form"
                    v-model="valid">
                <v-container class="">
                    <v-row>
                        <v-col
                                cols="12"
                        >
                            <h2>{{ $t('seller.seller') }}</h2>

                        </v-col>

                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    :label="$t('global.first_name')"
                                    :rules="[rules.required]"
                                    v-model="seller.first_name"
                            />
                        </v-col>

                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    :label="$t('global.name')"
                                    :rules="[rules.required]"
                                    v-model="seller.last_name"
                            />
                        </v-col>

                        <v-col
                                cols="12"
                                md="12"
                        >
                            <v-text-field
                                    :label="$t('global.email')"
                                    :rules="[rules.required]"
                                    v-model="seller.email"
                            />
                        </v-col>

                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    :label="$t('global.password')"
                                    type="password"
                                    :rules="[rules.required, rules.min]"
                                    v-model="seller.password"
                            />
                        </v-col>

                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    :label="$t('global.confirm_password')"
                                    type="password"
                                    :rules="[rules.required, rules.passwordMatch]"
                            />
                        </v-col>

                        <v-col
                                cols="12"
                        >
                            <v-switch
                                    v-model="seller.enabled"
                                    :label="$t('global.enabled')"
                            />
                        </v-col>

                        <v-col
                                cols="12"
                                md="12"
                        >
                            <v-text-field
                                    :label="$t('global.phone')"
                                    v-model="seller.phone"
                            />
                        </v-col>

                        <v-col
                                cols="12"
                        >
                            <v-btn
                                    @click="save"
                                    color="success"
                            >
                                <template v-if="!seller.id">{{ $t('seller.save_seller') }}</template>
                                <template v-if="seller.id">{{ $t('seller.update_seller') }}</template>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card>
        <v-snackbar
                v-model="snackbar"
                :color="color"
        >
            {{ message }}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                {{ $t('global.close') }}
            </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
    export default {
        name: 'Seller',

        beforeMount() {
            this.load();
        },

        data() {
            return {
                breadcrumb: [
                    {
                        text: this.$i18n.t('global.stores'),
                        disabled: false,
                        href: '/stores',
                    },
                    {
                        text: this.$i18n.t('global.store'),
                        disabled: false,
                        href: '/stores/' + this.$route.params.store_id,
                    },
                    {
                        text: this.$i18n.t('global.sellers'),
                        disabled: false,
                        href: '/stores/' + this.$route.params.store_id + '/sellers',

                    },
                    {
                        text: this.$i18n.t('global.seller'),
                        disabled: true,
                        href: '/stores/' + this.$route.params.store_id + '/sellers/' + this.$route.params.seller_id,

                    },
                ],
                snackbar: false,
                color: 'info',
                message: '',
                seller: {},
                valid: false,
                loading: false,
                rules: {
                    required: value => !!value || this.$i18n.t('global.required'),
                    min: v => v.length >= 8 || this.$i18n.t('global.8_min_characters'),
                    passwordMatch: (v) => v === this.seller.password || this.$i18n.t('global.passwords_mismatch'),
                },
            };
        },

        methods: {
            load() {
                if (this.$route.params.store_id && this.$route.params.seller_id) {
                    this.loading = true;
                    this.$axios.get('stores/' + this.$route.params.store_id + '/sellers/' + this.$route.params.seller_id)
                        .then(response => {
                            this.loading = false;
                            this.seller = response.data;
                        });
                }
            },
            save() {
                this.$refs.form.validate();
                if (!this.valid) return false;

                this.loading = true;
                let promise = '';
                if (this.$route.params.seller_id) {
                    promise = this.$axios.put('stores/' + this.$route.params.store_id + '/sellers/' + this.$route.params.seller_id, this.seller);
                } else {
                    promise = this.$axios.post('stores/' + this.$route.params.store_id + '/sellers', this.seller);
                }

                promise
                    .then(response => {
                        this.loading = false;
                        this.seller = response.data;
                        this.snackbar = true;
                        this.message = this.$i18n.t('seller.seller_saved');
                        this.color = 'info';

                    })
                    .catch(() => {
                        this.snackbar = true;
                        this.message = this.$i18n.t('seller.seller_save_failed');
                        this.color = 'error';
                    });
            }
        },

        computed: {},
    }
</script>